<app-dashboard-header [title]="'referral partner portal'" [dashboardType]="dashboardType"></app-dashboard-header>
<div class="bg-light-blue w-full pb-6">
  <p class="md:text-3xl text-xl text-center pt-8 pb-4 font-semibold">
    Account Preferences
  </p>
  <app-account-personal-info-form
    [form]="accountForm"
    [dashboardRoute]="dashboardType"
    [showJobTitleField]="true"
    [phoneMask]="'(000) 000-0000'"
    [phoneValidationErrorKey]="'mask'"
    (saveRequested)="onPreferencesFormSubmit()"
    (cancelRequested)="onPreferencesCancel()"
    (changePasswordRequested)="openChangePasswordModal()"
  ></app-account-personal-info-form>

  <form [formGroup]="companyInfoForm" (ngSubmit)="onCompanyInfoFormSubmit()" class="max-w-[98%] mx-auto">
    <mat-card class="personal-details-container overflow-x-auto w-full mt-1 mb-8 border-2 p-4 ml-auto mr-auto bg-white rounded-lg">
      <mat-card-content>
        <div class="mt-2 mb-4">
          <p class="text-2xl mb-2 font-bold">Company Information</p>
          <hr class="bg-green h-[3px] border-none">
        </div>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div class="col-span-1">
            <label for="managerFirstName" class="form-label">Manager First Name</label>
            <mat-form-field appearance="outline">
              <input id="managerFirstName" matInput formControlName="managerFirstName" required>
              @if (companyInfoForm.get('managerFirstName')?.hasError('required')) {
                <mat-error>Manager First Name is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="managerLastName" class="form-label">Manager Last Name</label>
            <mat-form-field appearance="outline">
              <input id="managerLastName" matInput formControlName="managerLastName" required>
              @if (companyInfoForm.get('managerLastName')?.hasError('required')) {
                <mat-error>Manager Last Name is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="managerEmail" class="form-label">Manager Email</label>
            <mat-form-field appearance="outline">
              <input id="managerEmail" matInput formControlName="managerEmail" required email>
              @if (companyInfoForm.get('managerEmail')?.hasError('required')) {
                <mat-error>Manager Email is required.</mat-error>
              }
              @if (companyInfoForm.get('managerEmail')?.hasError('email')) {
                <mat-error>Please enter a valid email address.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="managerContactFaxNumber" class="form-label">Fax # for Information</label>
            <mat-form-field appearance="outline">
              <input id="managerContactFaxNumber" mask="(000) 000-0000" matInput formControlName="managerContactFaxNumber" type="tel" required>
              @if (companyInfoForm.get('managerContactFaxNumber')?.hasError('required')) {
                <mat-error>Fax # for Information is required.</mat-error>
              }
              @if (companyInfoForm.get('managerContactFaxNumber')?.hasError('mask')) {
                <mat-error>Please enter a 10-digit phone number.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="managerChartNotesFaxNumber" class="form-label">Fax # for Chart Note</label>
            <mat-form-field appearance="outline">
              <input id="managerChartNotesFaxNumber" mask="(000) 000-0000" matInput formControlName="managerChartNotesFaxNumber" type="tel" required>
              @if (companyInfoForm.get('managerChartNotesFaxNumber')?.hasError('required')) {
                <mat-error>Fax # for Chart Note is required.</mat-error>
              }
              @if (companyInfoForm.get('managerChartNotesFaxNumber')?.hasError('mask')) {
                <mat-error>Please enter a 10-digit phone number.</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        @if (companyInfoForm.dirty) {
          <div class="flex justify-end space-x-4">
            <button class="text-gray-800 bg-gray-300 hover:bg-gray-400 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
              style="margin-right: 5px;"
              type="button"
              (click)="onCompanyInfoCancel()"
              >Cancel
            </button>
            <button class="text-white bg-black hover:bg-blue-800 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
              type="submit">Save
            </button>
          </div>
        }

      </mat-card-content>
    </mat-card>
  </form>


  <form [formGroup]="clinicInfoForm" (ngSubmit)="onClinicInfoFormSubmit()"  class="max-w-[98%] mx-auto">
    <mat-card class="personal-details-container overflow-x-auto w-full mt-1 mb-8 border-2 p-4 ml-auto mr-auto bg-white rounded-lg">
      <mat-card-content>
        <div class="mt-2 mb-4">
          <p class="text-2xl mb-2 font-bold">Clinics & Providers</p>
          <hr class="bg-green h-[3px] border-none">
        </div>
        @if (showClinicPendingApprovalBanner) {
          <div
            class="mb-4 flex items-center justify-between gap-3 rounded-md border border-[#e6c200] bg-[#fff4cc] px-4 py-3 text-[#6a4d00]">
            <p class="m-0 flex items-start gap-2 text-sm">
              <span
                aria-hidden="true"
              class="mt-0.5 inline-flex h-[18px] min-h-[18px] w-[18px] min-w-[18px] items-center justify-center rounded-full bg-yellow-400 text-xs font-bold leading-none text-[#6a4d00]">!</span>
              Your changes have been submitted and are now pending approval. They will take effect once approved.
            </p>
            <button
              type="button"
              class="whitespace-nowrap rounded border border-[#6a4d00] bg-transparent px-3 py-1.5 text-xs font-semibold text-[#6a4d00] hover:bg-[rgba(106,77,0,0.08)] disabled:cursor-not-allowed disabled:opacity-60"
              [disabled]="discardClinicPendingChangesInProgress"
              (click)="onDiscardClinicPendingChanges()">
              Discard Changes
            </button>
          </div>
        }
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div class="w-full col-span-2 flex flex-col gap-y-4">
            <!-- TODO: Add error handling -->
            <app-clinic-search-dropdown
              [required]="true"
              [dropdownLabel]="'Select First Clinic'"
              [dropdownSelectionFormControl]="firstClinicCtrl"
              [showError]="false"
              >
            </app-clinic-search-dropdown>

            <!-- TODO: Add error handling -->
            <app-provider-multiselect
              [required]="true"
              [label]="'Select Providers'"
              [selectionFormControl]="firstProvidersCtrl"
              [otherProviderNameFormControl]="firstClinicOtherProviderNameCtrl"
              [otherProviderNPIFormControl]="firstClinicOtherProviderNPICtrl"
              [removeProviderFormControl]="firstClinicRemoveProviderCtrl"
              [readOnly]="clinicInfoForm.disabled"
              [clinicId]="firstClinicCtrl.value"
              [originalClinicId]="originalFirstClinicId"
              [selectedOptions]="displayFirstClinicProviderIds",
              [hasOtherProvider]="displayHasFirstOtherProvider",
              [pendingRemovalProviderIds]="displayFirstPendingRemovalProviderIds"
              >
            </app-provider-multiselect>
          </div>
          <div class="w-full col-span-2 flex flex-col gap-y-4">
            <div class="flex items-start gap-2">
              <app-clinic-search-dropdown
                class="min-w-0 flex-1"
                [required]="false"
                [dropdownLabel]="'Select Second Clinic'"
                [dropdownSelectionFormControl]="secondClinicCtrl"
                [showError]="false"
                >
              </app-clinic-search-dropdown>
              @if (secondClinicCtrl.value && !clinicInfoForm.disabled) {
                <button
                  type="button"
                  class="mt-4 inline-flex h-12 w-12 shrink-0 items-center justify-center text-3xl font-bold leading-none text-red-600 hover:text-red-800"
                  aria-label="Remove Clinic 2"
                  title="Remove Clinic 2"
                  (click)="onRemoveSecondClinic()"
                  >
                  &times;
                </button>
              }
            </div>

            <!-- TODO: Add error handling -->
            <app-provider-multiselect
              [required]="!!secondClinicCtrl.value"
              [label]="'Select Providers'"
              [selectionFormControl]="secondProvidersCtrl"
              [otherProviderNameFormControl]="secondClinicOtherProviderNameCtrl"
              [otherProviderNPIFormControl]="secondClinicOtherProviderNPICtrl"
              [removeProviderFormControl]="secondClinicRemoveProviderCtrl"
              [readOnly]="clinicInfoForm.disabled"
              [clinicId]="secondClinicCtrl.value"
              [originalClinicId]="originalSecondClinicId"
              [selectedOptions]="displaySecondClinicProviderIds",
              [hasOtherProvider]="displayHasSecondOtherProvider",
              [pendingRemovalProviderIds]="displaySecondPendingRemovalProviderIds"
              >
            </app-provider-multiselect>
          </div>
        </div>

        @if (clinicInfoForm.dirty && !clinicInfoForm.disabled) {
          <div class="flex justify-end space-x-4">
            <button class="text-gray-800 bg-gray-300 hover:bg-gray-400 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
              style="margin-right: 5px;"
              type="button"
              (click)="onClinicInfoCancel()"
              >Cancel
            </button>
            <button class="text-white bg-black hover:bg-blue-800 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
              type="submit">Submit to Admin
            </button>
          </div>
        }
      </mat-card-content>

    </mat-card>
  </form>
  <app-contact-us-info [dashboardType]="dashboardType"></app-contact-us-info>
</div>
